angular.module('app').component('objectRouteMobile', {
    templateUrl: 'js/components/object-route-mobile/index.html',
    controller: ObjectRouteMobileController,
    controllerAs: '$orm',
    bindings: {
        object: '=',
        changeStatsView: '&',
        isStatsView: '&',
    },
});

ObjectRouteMobileController.$inject = ['$translate', '$stateParams'];

function ObjectRouteMobileController($translate, $stateParams) {
    this.mobileListView = true;
    this.currentEnd = null;
    this.currentDateStart = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    this.currentObjectId = null;
    this.currentMessageId = null;
    this.currentX = null;
    this.currentY = null;
    this.currentVectorAngle = null;
    this.currentIgnition = null;
    this.hash = $stateParams.hash;

    this.getTranslations = function () {
        var translations = {
            loading: $translate.instant('routes.loading'),
        };
        var objectFields = [
            'date',
            'vectorSpeed',
            'ignition',
            'fuelUsage',
            'business',
            'mileage',
            'rpm',
            'voltage',
            'fuelLevel',
            'ecoLevel',
            'ecoAlarm',
            'ecoQuality',
            'gasPedal',
            'fuelInputLevel',
            'fuelLevelCan',
        ];

        for (var index in objectFields) {
            var item = objectFields[index];
            translations[item] = $translate.instant(
                'routes.params.' + item
            );
        }

        return translations;
    };

    this.toggleMobileListView = function () {
        this.changeStatsView();

        if (this.isStatsView()) {
            this.refreshRouteData();
        }

        setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
        }, 300);
    };

    this.mobileListView = function () {
        return this.isStatsView();
    };

    this.refreshRouteData = function () {
        this.currentEnd = moment().format('YYYY-MM-DD HH:mm:ss');
        this.currentTime = moment
            .utc(this.object.last.GpsTime)
            .format('YYYY-MM-DD HH:mm:ss');
        this.currentObjectId = this.object.objectId;
        this.currentMessageId = this.object.last.messageId;
        this.currentX = this.object.last.x;
        this.currentY = this.object.last.y;
        this.currentVectorAngle = this.object.last.angle;
        this.currentIgnition = this.object.last.speed;
    };

    this.$doCheck = function () {
        if (this.isStatsView() === true && this.currentMessageId !== this.object.last.messageId) {
            this.refreshRouteData();
        }
    };
}
